import MathUtils from '../../util/MathUtils.js';
import LineFunctionResult from './LineFunctionResult.js';
import {nicelyRounded} from '../../util/CommonUtils.js';

export default class LineFunctionSd {
	constructor(labelPattern, params) {
		this._labelPattern = labelPattern;
		this._numOfSd = params.numOfSd || 1;
	}

	calculateLine(x, y, xAxis) {
		const {mean, sd} = MathUtils.standardDeviation(y);
		const sdVal = sd * this._numOfSd;
		const x1 = mean + sdVal, x2 = mean - sdVal;
		return [
			new LineFunctionResult([[xAxis[0], x1], [xAxis[1], x1]], this._labelPattern.replace('${value}', nicelyRounded(x1))),
			new LineFunctionResult([[xAxis[0], x2], [xAxis[1], x2]], this._labelPattern.replace('${value}', nicelyRounded(x2)))
		];
	}
}